<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">台账类型：</div>
        <Select v-model="search.type" style="width: 7.5em;margin-right: 10px" placeholder="选择台账类型" clearable>
          <Option v-for="item in wasteTypeEnum" :key="item.id" :value="item.id">{{ item.name }}</Option>
        </Select>
        <div class="label">危废名称：</div>
        <Select v-model="search.wasteTypeId" style="width: 15em" placeholder="选择危废名称筛选" clearable>
          <Option v-for="item in wasteTypeList" :key="item.id" :value="item.id">{{ item.wasteName }} - {{
            item.wasteTypeName }}({{ item.wasteTypeCode }})</Option>
        </Select>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px; margin-left: 10px"
          @on-change="dateSelect($event)"></DatePicker>
        <i-input prefix="ios-search" placeholder="输入危废关键字" v-model="search.searchName"
          style="width: auto; margin-left: 10px" />
        <i-button type="default" @click="searchFunc" style="margin-left: 1em">搜索</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :max-height="table.maxHeight" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer :page-size="40" @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align: right; margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 5.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue"; // 操作栏组件
import { timeStamp } from "../../../util/common/date"; // 时间转化工具
import { emComputed } from "../../../util/common/fontSize"; // em转化工具
import { Resize } from "../../../util/common/resize";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            title: "危废名称",
            key: "wasteName",
            align: "center",
          },
          {
            title: "包装编码",
            key: "numericIdentifier",
            align: "center",
          },
          {
            title: "危废编号",
            key: "wasteTypeCode",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findWasteTypeCodeById(params.row.wasteTypeId)
                ),
              ]);
            },
          },
          {
            title: "危废重量(吨)",
            key: "wasteWeight",
            align: "center",
          },
          // {
          //   title: "备注信息",
          //   key: "wasteNotes",
          //   align: "center",
          // },
          {
            title: "入库操作员",
            key: "inboundOperatorName",
            align: "center",
          },
          {
            title: "入库时间",
            key: "inboundDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.inboundDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          },
          {
            title: "出库操作员",
            key: "outboundOperatorName",
            align: "center",
          },
          {
            title: "出库时间",
            key: "outboundDate",
            width: 180,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.outboundDate, "yyyy-MM-dd HH:mm")
                ),
              ]);
            },
          },
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 40,
        total: 0,
        loading: true,
        maxHeight: null,
      },
      // 查询
      search: {
        type: 0,
        searchName: null,
        wasteTypeId: null,
        startDate: null,
        endDate: null,
      },
      wasteTypeEnum: [{ "name": "库存记录", "id": 1 }, { "name": "出入记录", "id": 0 }], // 下拉列表
      wasteTypeList: [], // 下拉列表
    };
  },
  components: {
    toolbar,
  },
  created() {
    this.getWasteType(); // 下拉数据初始化
    this.getData();
    this.tableInit(); // 表格初始化
    this.getInventory(); //全部重量数据汇总
    window.addEventListener("resize", this.tableInit);
  },
  methods: {
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Waste.getWasteInfoList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search,
        },
        ["uuid", "company"]
      ).then((res) => {
        if (res.code == 0) {
          // 获取成功
          let data = res.data.list;
          this.table.data = data;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    // 获取危废类型
    getWasteType() {
      this.$api.Waste.getWasteTypeAll({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取危废类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取库存总量数据
    getInventory() {
      this.$api.Waste.inventory({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          //this.wasteTypeList = res.data;
        } else {
          this.$Notice.warning({
            title: "获取危废类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    findWasteTypeCodeById(id) {  
      const waste = this.wasteTypeList.find(waste => waste.id === id);  
      return waste ? waste.wasteTypeName + " (" + waste.wasteTypeCode + ")" : null;  
    },
    // 选择时间
    dateSelect(date) {
      this.search.startDate = date[0];
      this.search.endDate = date[1];
    },
    // 表格高度计算
    tableInit() {
      let headerH = emComputed(14.5); // header高度7em加操作栏5.5em转换px， 2em的上下边距分页组件
      this.table.maxHeight = window.innerHeight - headerH - 32; // 32px的分页组件高度
      if (this.$route.path != "/chome/reportTable") {
        window.removeEventListener("resize", this.tableInit);
      }
    },
  },
};
</script>